import { render, staticRenderFns } from "./PostPayment.vue?vue&type=template&id=561f624e&scoped=true&"
import script from "./PostPayment.vue?vue&type=script&lang=js&"
export * from "./PostPayment.vue?vue&type=script&lang=js&"
import style0 from "./PostPayment.vue?vue&type=style&index=0&id=561f624e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f624e",
  null
  
)

export default component.exports